import { jsonMember, jsonObject } from 'typedjson';
import { SequenceSearchResultDataResponse } from '@api/sequence/responses/sequence-search-result-data.response';

@jsonObject
export class SequenceSearchResultDetailsResponse {
  @jsonMember readonly id!: string;
  @jsonMember readonly rid!: string;
  @jsonMember readonly createdAt!: Date;
  @jsonMember readonly data!: SequenceSearchResultDataResponse;
}
